
export const ADD_ITEM_BAR = 'ADD_ITEM_BAR';
export const GET_POWERPLANT_INV='GET_POWERPLANT_INV';
export const UPDATE_TE002_FORM='UPDATE_TE002_FORM';
export const ADD_DYNAMIC_ACCESSORIES='ADD_DYNAMIC_ACCESSORIES';
export const ADD_DYNAMIC_ADDITIONAL='ADD_DYNAMIC_ADDITIONAL';
export const ADD_DYNAMIC_HARDWARE='ADD_DYNAMIC_HARDWARE';
export const POWERPLANT_DETLS_LOADER='POWERPLANT_DETLS_LOADER';
export const DELETE_POWER_COMPONENT='DELETE_POWER_COMPONENT';